export const template = {
  name: 'Nom',
  templateAsylumCenter: 'Template centre',
  templateResidence: 'Template logements',
  editTemplate: 'Edit templates',
  template: 'Template',
  addTemplate: 'Ajouter un template',
};
